import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Box, Button, Stack } from "grommet";
import { Close } from "grommet-icons";
import ScaleLoader from "react-spinners/ScaleLoader";

class ChatappletN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bwaitloader: true,
      width: 800,
      height: 600,
      xOffset: 0,
      yOffset: 0,
      isTracking: false,
    };

    this.initDrag = this.initDrag.bind(this);
    this.initResize = this.initResize.bind(this);
    this.doTrack = this.doTrack.bind(this);
    this.stopTrack = this.stopTrack.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ bwaitloader: false });
    }, 8000);
  }

  componentWillUnmount() {
    this.stopTrack();
  }

  initDrag(e) {
    if (e.target.closest("button")) return;

    e.preventDefault();
    this.trackingMode = "drag";
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.startLeft = this.state.xOffset;
    this.startTop = this.state.yOffset;

    this.setState({ isTracking: true });
    document.addEventListener("mousemove", this.doTrack);
    document.addEventListener("mouseup", this.stopTrack);
  }

  initResize(e) {
    e.preventDefault();
    e.stopPropagation();
    this.trackingMode = "resize";
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.startWidth = this.state.width;
    this.startHeight = this.state.height;

    this.setState({ isTracking: true });
    document.addEventListener("mousemove", this.doTrack);
    document.addEventListener("mouseup", this.stopTrack);
  }

  doTrack(e) {
    if (this.trackingMode === "drag") {
      this.setState({
        xOffset: this.startLeft + (e.clientX - this.startX),
        yOffset: this.startTop + (e.clientY - this.startY),
      });
    } else if (this.trackingMode === "resize") {
      this.setState({
        width: Math.max(400, this.startWidth + (e.clientX - this.startX)),
        height: Math.max(300, this.startHeight + (e.clientY - this.startY)),
      });
    }
  }

  stopTrack() {
    this.setState({ isTracking: false });
    document.removeEventListener("mousemove", this.doTrack);
    document.removeEventListener("mouseup", this.stopTrack);
  }

  render() {
    let source =
      "https://demoportalchatbot.hpecic.net?user_name=" +
      this.props.uname +
      "&user_email=" +
      this.props.uemail;
    if (this.props.needhelp) {
      source += "&needhelp=yes";
    }

    const { width, height, xOffset, yOffset, isTracking } = this.state;

    // Use pure React Portal instead of Grommet Layer to bypass internal prop errors
    return ReactDOM.createPortal(
      <Box
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Replaces Grommet's backdrop cleanly
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        //onClick={this.props.hide}
      >
        <Box
          style={{
            position: "relative",
            width: `${width}px`,
            height: `${height}px`,
            transform: `translate3d(${xOffset}px, ${yOffset}px, 0)`,
            WebkitTransform: `translate3d(${xOffset}px, ${yOffset}px, 0)`,
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
            userSelect: isTracking ? "none" : "auto",
          }}
          background="white"
          round="small"
          elevation="xlarge"
          overflow="hidden"
          onClick={(e) => e.stopPropagation()} // Prevents overlay click from breaking window frame
        >
          <Stack fill>
            <Box fill>
              {/* Header Title Drag Bar Area */}
              <Box
                align="end"
                justify="end"
                direction="row"
                background={{ color: "brand" }}
                onMouseDown={this.initDrag}
                style={{ cursor: "move", userSelect: "none" }}
                pad="xsmall"
              >
                <Box onMouseDown={(e) => e.stopPropagation()}>
                  <Button
                    icon={<Close />}
                    secondary
                    onClick={this.props.hide}
                  />
                </Box>
              </Box>

              {/* Central Frame Viewport Container */}
              <Box fill background="light-1">
                <iframe
                  style={{
                    height: "100%",
                    width: "100%",
                    border: "none",
                    pointerEvents: isTracking ? "none" : "auto",
                  }}
                  src={source}
                  allowFullScreen
                ></iframe>
              </Box>

              {/* Window Resize Corner Controller Handle Node */}
              <Box
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: "16px",
                  height: "16px",
                  cursor: "se-resize",
                  background:
                    "linear-gradient(135deg, transparent 40%, #777 40%, transparent 60%, #777 60%)",
                  zIndex: 100,
                }}
                onMouseDown={this.initResize}
              />
            </Box>

            {/* Spinner Status Elements */}
            {this.state.bwaitloader && (
              <Box
                fill
                align="center"
                justify="center"
                style={{ position: "absolute", pointerEvents: "none" }}
              >
                <ScaleLoader
                  color="#008000"
                  height={20}
                  speedMultiplier={2}
                  width={5}
                />
              </Box>
            )}
          </Stack>
        </Box>
      </Box>,
      document.body,
    );
  }
}

export default ChatappletN;
